export default {
    SMS: 1,
    MMS: 2
};
